import { PlatformSourcesEnum } from '@enums'

const platformSourcesEnumMap = {
  0: PlatformSourcesEnum.Ebay,
  1: PlatformSourcesEnum.Shopify,
  2: PlatformSourcesEnum.NA,
  3: PlatformSourcesEnum.NA,
  4: PlatformSourcesEnum.BigCommerce,
  5: PlatformSourcesEnum.Magento,
  6: PlatformSourcesEnum.ShipStation,
  7: PlatformSourcesEnum.Amazon,
  8: PlatformSourcesEnum.WooCommerce,
  9: PlatformSourcesEnum.API,
  10: PlatformSourcesEnum.BackerKit,
  11: PlatformSourcesEnum.ShipBob,
  12: PlatformSourcesEnum.CrateJoy,
  13: PlatformSourcesEnum.Stitchlabs,
  14: PlatformSourcesEnum.QuickBooks,
  15: PlatformSourcesEnum.ExcelUpload,
  16: PlatformSourcesEnum.Walmart,
  17: PlatformSourcesEnum.TicTail,
  18: PlatformSourcesEnum.SquareSpace,
  19: PlatformSourcesEnum.WooCommerceV2,
  20: PlatformSourcesEnum.SquareConnect,
  21: PlatformSourcesEnum.Returnly,
  22: PlatformSourcesEnum.Sps
}

const mapPlatformSourceFromAPI = (id) => ({
  id,
  name: platformSourcesEnumMap[id] !== undefined ? platformSourcesEnumMap[id] : '-'
})

export default {
  mapPlatformSourceFromAPI
}
